import React from "react"

import { Wrapper } from "./styles"

const Footer = ({ element }) => <Wrapper dangerouslySetInnerHTML={{ __html: element.text }} />

export default Footer
